<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    콘텐츠관리

<!--
                    <div class="filter-select-div">
                        <el-select class="select" v-model="selectedLang" @change="handlerChangeLang()">
                            <el-option v-for="lang in languages" :key="`lang${lang.c_idx}`" :value="lang.c_idx" :label="lang.c_lang_ko"></el-option>
                        </el-select>
                    </div>
-->

                    <el-button class="title_btn" @click="moveCreate" type="primary">등록</el-button>
                    <div class="clear"></div>
                </div>
                <div class="refund_caption">
                    콘텐츠들은 APP에서 이름 오름차순으로 우선노출 합니다.                 </div>
                <div class="list-content">
                    <content-list-component v-if="showList" :contentType="'content'" :defaultLang="30"></content-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

        </div>
    </div>
</template>

<script>
    import {appLanguage} from "@/service/languageService";
    import ContentListComponent from "@/components/content/ContentListComponent";
    import util from "@/mixins/util";
    export default {
        name: 'Content',
        mixins: [],
        components: {ContentListComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {
                languages: appLanguage,
                selectedLang: '',
                showList: true,
            }
        },
        created() {
            if(util.isEmpty(this.$route.query.cid)) {
                this.selectedLang = this.languages[0].c_idx;
            }else{
                this.selectedLang = Number(this.$route.query.cid);
            }

        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
        },
        methods: {
            handlerChangeLang() {
                this.showList = false;
                this.$router.replace(this.$route.path);
                this.$nextTick(() => {
                    this.showList = true;
                })
            },
            moveCreate() {
                this.$router.push('/content/content/create');
            },
        },
        watch: {},
    }
</script>
